import { Modal, PrimaryButton, Typography } from '@weareopenr/component-library';
import { useForm } from 'react-hook-form';
import VenueDetailsFields from 'src/components/VenueDetailsFields';
import { useUpdateVenueDetails } from 'src/hooks/useUpdateVenueDetails';
import ModalImg from 'src/assets/images/create-menu-item-modal.png';
import { IFormValues } from './types';
import { IVenueDetails } from 'src/components/VenueDetails/VenueDetails';
import styles from './VenueDetailsEditModal.module.scss';

interface IVenueDetailsEditForm extends IVenueDetails {
  onModalClose: () => void;
}

interface IVenueDetailsEditModal extends IVenueDetailsEditForm {
  isModalOpen: boolean;
}

const VenueDetailsEditForm = ({ venue, onModalClose }: IVenueDetailsEditForm) => {
  const { mutate: updateVenueDetails, isLoading } = useUpdateVenueDetails(onModalClose);

  const formFields = useForm<IFormValues>({
    defaultValues: {
      name: venue.name,
      isTrial: venue.isTrial,
    },
    mode: 'onChange',
  });

  const {
    handleSubmit,
    register,
    control,
    formState: { errors, isSubmitting },
  } = formFields;

  const onSubmit = async ({ name, isTrial }: IFormValues) => {
    updateVenueDetails({
      id: venue.venueId,
      body: { name, isTrial },
    });
  };

  return (
    <form
      className={styles['venue-details-form']}
      onSubmit={handleSubmit(onSubmit)}
      id="venue-form"
      aria-label="venue-form"
    >
      <Typography size="xxlarge" weight="semi-bold" className={styles['heading-text']}>
        Edit details for {venue.name}
      </Typography>
      <VenueDetailsFields register={register} control={control} errors={errors} />
      <PrimaryButton loading={isSubmitting || isLoading} size="full-width" type="submit">
        Save
      </PrimaryButton>
    </form>
  );
};

const VenueDetailsEditModal = ({ isModalOpen, onModalClose, venue }: IVenueDetailsEditModal) => {
  return (
    <Modal open={isModalOpen} closeModal={onModalClose} image={ModalImg} imageAlt="Picture of ingredients">
      <VenueDetailsEditForm venue={venue} onModalClose={onModalClose} />
    </Modal>
  );
};

export default VenueDetailsEditModal;
